import get from 'lodash/get';

const sessionStore = new class MagicStore {
	constructor() {
		try {
			this._data = JSON.parse(window.localStorage.getItem('localStore')) || {};
		} catch (e) {
			this._data = {};
		}
		this.$data = new Proxy(this._data, {
			get(target, prop) {
				return target[prop] || null;
			},
			set(target, prop, value) {
				target[prop] = value;
				window.localStorage.setItem('localStore', JSON.stringify(target));
				return true;
			}
		});
	}

	get(target, prop) {
		return get(this.$data, prop, '⚠ ' + prop);
	}
};

export default sessionStore;
